import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { 
  ChevronDown, BookOpen, Zap, Trophy, Layers, TrendingUp 
} from "lucide-react";

const PublicHeader = () => {
  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-maple rounded-lg flex items-center justify-center">
              <span className="text-white font-heading font-bold text-xl">C</span>
            </div>
            <div className="flex flex-col">
              <span className="font-heading font-bold text-xl text-slate-900 leading-tight">CanadaTestPrep</span>
              <span className="text-[10px] text-slate-500 leading-tight">powered by MaplePass</span>
            </div>
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/#how-it-works" className="text-slate-600 hover:text-maple transition-colors">How It Works</Link>
            {/* Features Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-1 text-slate-600 hover:text-maple transition-colors">
                  Features
                  <ChevronDown className="w-3 h-3" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-56">
                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link to="/features/chapter-practice" className="flex items-center gap-2">
                    <BookOpen className="w-4 h-4 text-maple" />
                    Chapter Practice
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link to="/features/simulations" className="flex items-center gap-2">
                    <Zap className="w-4 h-4 text-truenorth" />
                    Test Simulations
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link to="/features/mock-tests" className="flex items-center gap-2">
                    <Trophy className="w-4 h-4 text-yellow-500" />
                    Mock Tests
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link to="/features/flashcards" className="flex items-center gap-2">
                    <Layers className="w-4 h-4 text-purple-500" />
                    Flashcards
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link to="/features/analytics" className="flex items-center gap-2">
                    <TrendingUp className="w-4 h-4 text-emerald-500" />
                    Analytics & Insights
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <Link to="/#testimonials" className="text-slate-600 hover:text-maple transition-colors">Reviews</Link>
            <Link to="/#pricing" className="text-slate-600 hover:text-maple transition-colors">Pricing</Link>
          </div>

          <div className="flex items-center gap-3">
            <Link to="/login">
              <Button variant="ghost" className="text-slate-700" data-testid="login-btn">
                Log in
              </Button>
            </Link>
            <Link to="/register">
              <Button className="bg-maple hover:bg-maple-600 text-white rounded-full px-6" data-testid="get-started-btn">
                Get Started
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicHeader;
